import { useContext } from "react";
import { AuthContext } from "../components/AuthContextProvider";

export function useIsAuthorised() {
  const { accessToken, role } = useContext(AuthContext);

  return accessToken !== undefined && role !== undefined;
}
